import React from 'react';
import { CloseButton } from './buttons/base/CloseButton';
import '../styles/FullscreenOverlay.scss';

interface FullscreenOverlayProps {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export const FullscreenOverlay: React.FC<FullscreenOverlayProps> = ({ 
  title, 
  onClose, 
  children,
  className = ''
}) => {
  const handleOverlayClick = (e: React.MouseEvent) => {
    // Only close if clicking directly on the overlay container (backdrop area), not on content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContentClick = (e: React.MouseEvent) => {
    // Prevent clicks on content from bubbling to overlay
    e.stopPropagation();
  };

  return (
    <div className={`fullscreen-overlay ${className}`} onClick={handleOverlayClick}>
      <div className="fullscreen-overlay-backdrop"></div>
      <div className="fullscreen-overlay-content" onClick={handleContentClick}>
        <div className="fullscreen-overlay-header">
          {title && <div className="fullscreen-overlay-title">{title}</div>}
          <CloseButton onClick={onClose} />
        </div>
        <div className="fullscreen-overlay-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FullscreenOverlay;

